import type { AdminAgentStatus } from "../models/admin-agent.models";

export const ADMIN_AGENT_POLL_INTERVAL_MS = 2000;
export const ADMIN_AGENT_REQUEST_TIMEOUT_MS = 20000;
export const ADMIN_AGENT_MESSAGE_MAX_LENGTH = 12000;
export const ADMIN_AGENT_TITLE_MAX_LENGTH = 120;
// Preserve quoted values and comments while formatting only SQL clauses and bind placeholders.
export const ADMIN_AGENT_SQL_REVIEW_TOKENS =
  /'(?:''|\\.|[^'\\])*'|"(?:""|[^"])*"|--[^\r\n]*|\/\*[\s\S]*?\*\/|\?|\s*\b(SELECT|FROM|WHERE|ORDER\s+BY|GROUP\s+BY|HAVING|LIMIT|(?:LEFT|RIGHT|INNER|FULL|CROSS)(?:\s+OUTER)?\s+JOIN|JOIN|ON|AND|OR|UNION(?:\s+ALL)?)\b/gi;
export const ADMIN_AGENT_PANEL_ID = "admin-agent-panel";
export const ADMIN_AGENT_PANEL_WIDTH_STORAGE_KEY = "opslink.adminAgent.panelWidth";
export const ADMIN_AGENT_PANEL_DEFAULT_WIDTH = 480;
export const ADMIN_AGENT_PANEL_MIN_WIDTH = 320;
export const ADMIN_AGENT_PANEL_MAX_WIDTH = 1000;
export const ADMIN_AGENT_PANEL_DESKTOP_BREAKPOINT = 1024;
export const ADMIN_AGENT_PANEL_REMAINING_WORKSPACE_WIDTH = 360;
export const ADMIN_AGENT_PANEL_RESIZE_STEP = 24;

export const ADMIN_AGENT_STATUS_LABELS: Record<AdminAgentStatus, string> = {
  idle: "Ready",
  running: "Working",
  completed: "Completed",
  stopped: "Stopped",
  failed: "Failed",
  limit_reached: "Step limit reached",
};

export const ADMIN_AGENT_RESUMABLE_STATUSES: AdminAgentStatus[] = ["stopped", "failed", "limit_reached"];
